export enum CommentStatus {
    NOCOMMENT = 0,
    REJECTIONCOMMENT = 1,
    INFORMATIVECOMMENT = 2
}
